// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2l0ma","legacyBtn":"MutateMid_legacyBtn__1TIFb"};